import styled from 'styled-components'
import { getColorStatus } from '../../../utils/utils'
import botsBG from 'assets/icons/botsBG.png'
import { colorsEnum } from '../../../utils/GlobalStyles'

export const ScrollBlockWrapper = styled.div`
  position: relative;
  height: calc(100vh - 131px);
  overflow-y: scroll;
  &::-webkit-scrollbar {
    display: none;
    scrollbar-width: none;
  }
`
export const FullValue = styled.span`
  display: none;
  width: 100%;
`

export const ShortedValue = styled.span`
  width: 100%;
  display: flex;
`

export const HoverBlock = styled.span`
  &:hover {
    ${FullValue} {
      display: flex;
    }
    ${ShortedValue} {
      display: none;
    }
  }
`
export const ItemWrapper = styled(HoverBlock)<{ isMarket?: boolean }>`
  display: flex;
  width: 100%;
  background: ${({ theme }) => theme.black};
  border: 1px solid #ffffff00;
  &:nth-child(2n-1) {
    background: none;
  }
  &:hover {
    border-color: ${({ theme }) => theme.white66};
  }
  position: relative;
`
export const TableViewCol = styled.div`
  min-width: 7%;
  max-width: 7%;
  display: flex;
  justify-content: flex-start;
  white-space: nowrap;
  border: 1px solid #ffffff00;
  padding: 4px;
  &:not(:last-child) {
    border-right: 1px solid #ffffff22;
  }
  &:hover {
    cursor: default;
  }
`

export const ExCol = styled(TableViewCol)`
  min-width: 9%;
  max-width: 9%;
`
export const MarketCol = styled(TableViewCol)`
  max-width: 11%;
  min-width: 11%;
`
export const VolumeCol = styled(TableViewCol)`
  min-width: 6%;
  max-width: 6%;
`
export const PriceCol = styled(TableViewCol)`
  min-width: 15%;
  max-width: 15%;
`
export const FilledCol = styled(TableViewCol)<{ filledPercent?: number }>`
  justify-content: center;
  position: relative;
  min-width: 4%;
  max-width: 4%;
  &:after {
    content: '';
    position: absolute;
    z-index: 0;
    width: ${({ filledPercent }) => (filledPercent ? `${filledPercent}%` : 0)};
    height: 10%;
    background: ${({ filledPercent, theme }) =>
      filledPercent && filledPercent < 100
        ? theme.getColorWithOpacity(colorsEnum.yellow, 20)
        : filledPercent && filledPercent >= 100
        ? theme.getColorWithOpacity(colorsEnum.green, 20)
        : 'none'};
    left: 0;
    bottom: 0;
  }
`
export const StatusesCol = styled(TableViewCol)`
  justify-content: center;
`
export const ExpectedProfitCol = styled(TableViewCol)`
  min-width: 10%;
  max-width: 10%;
`
export const ProfitCol = styled(TableViewCol)`
  min-width: 7.5%;
  max-width: 7.5%;
`
export const DeltaCol = styled(TableViewCol)`
  min-width: 4%;
  max-width: 4%;
`
export const FeeCol = styled(TableViewCol)`
  min-width: 4%;
  max-width: 4%;
`
export const TimeCol = styled(TableViewCol)`
  justify-content: center;
`

export const ColoredBySide = styled.span<{ side?: string }>`
  color: ${({ side, theme }) => (side === 'BUY' ? theme.green : side === 'SELL' ? theme.red : '#fff')};
  display: flex;
`

export const ColoredByStatus = styled.span<{ status: string }>`
  color: ${({ status }) => getColorStatus(status)};
`

export const ColoredByBool = styled.span<{ isGood: boolean; gray?: boolean }>`
  color: ${({ isGood, gray, theme }) => (isGood ? (gray ? theme.white66 : theme.green) : theme.red)};
`

export const ColoredByNumber = styled.span<{ num: number }>`
  color: ${({ num, theme }) => (num > 0 ? theme.green : num < 0 ? theme.red : theme.white66)};
`

export const ColoredByLogicType = styled.span<{ logicType?: string }>`
  color: ${({ logicType, theme }) => (logicType === 'LIMIT' ? theme.yellow : theme.green)};
`

export const YellowSpan = styled.span`
  color: ${({ theme }) => theme.yellow};
`
export const GraySpan = styled.span`
  color: #ffffff66;
  display: flex;
`

export const ButtonsCol = styled(TableViewCol)`
  max-width: 4.5%;
  min-width: 4.5%;
  justify-content: space-around;
`
export const LogicTypeCol = styled(TableViewCol)`
  max-width: 3%;
  min-width: 3%;
  justify-content: center;
`

export const ShowFullButton = styled.button`
  //position: absolute;
  left: 4px;
  top: 4px;
  z-index: 1;
  font-size: 11px;
  line-height: 1;
  padding: 1px 2px;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.getColorWithOpacity(colorsEnum.green, 30)};
  color: ${({ theme }) => theme.getColorWithOpacity(colorsEnum.green, 30)};
  &:hover {
    border: 1px solid ${({ theme }) => theme.green};
    color: ${({ theme }) => theme.green};
  }
  &:active {
    color: #fff;
    background: ${({ theme }) => theme.green};
  }
`

export const DetailsBlock = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  transform: translateY(100%);
  //background:#000;
  z-index: 4;
  //background-image: url(${botsBG});
  background: ${({ theme }) => theme.dark};
`

export const IconImg = styled.div<{ src: string }>`
  position: relative;
  margin-right: 4px;
  height: 14px;
  width: 14px;
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`

export const ScrollTopButton = styled.button`
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  background: #000;
  border: 1px solid #fff;
  border-radius: 50%;
  color: #000;
  position: sticky;
  bottom: 100px;
  left: calc(100% - 200px);
  opacity: 0.3;
  &:hover {
    opacity: 1;
  }
  svg {
    transform: rotate(180deg);
    width: 16px;
    height: 16px;
    path {
      stroke: #fff;
    }
  }
`
